import React, { useState } from "react";
import app from "../../Main/base";
import { useEffect } from "react";
import { useParams } from "react-router";
//------
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ListItem, ListItemText, List, Button } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { Container } from "@material-ui/core";
import Form from "react-bootstrap/Form";

import "./TripContract.css";

import TripChecklistOwner from "../TripPhases/TripCheckList/TripChecklistOwner";
import OwnerTripChecklist from "../TripPhases/TripCheckList/OwnerTripChecklist";
import { set } from "date-fns";

import TripContractOwnerForm from "./Forms/TripContractOwnerForm";
import TripContractPilotForm from "./Forms/TripContractPilotForm";

import {
  getImageUrl,
  putStorageItem,
  getUserNameById,
} from "../../Utils/Utils";

import { useDropzone } from "react-dropzone";
import { getDoc } from "../../Utils/Utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    flexBasis: "33.33%",
  },
  thirdHeading: {
    fontSize: theme.typography.pxToRem(15),
    // color: theme.palette.text.secondary,
    flexBasis: "33.33%",
  },
  receivedRequest: {
    backgroundColor: "yellow",
  },
  sentRequest: {
    backgroundColor: "red",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
  },
}));

const TripContract = (props) => {
  const defaultImage =
    "data:image/jpeg;base64,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";
  const { id } = useParams();
  const classes = useStyles();

  const [ownerChecklist_Id, setOwnerChecklist_Id] = useState("");
  const [pilotChecklist_Id, setPilotChecklist_Id] = useState("");

  // Trip
  const [loading, setLoading] = useState(true);
  const [thisTrip, setThisTrip] = useState([]);

  //sub Collection of Trip, CheckList
  const [thisTripContract, setThisTripContract] = useState({});

  // Setting images
  const [image, setImage] = useState(null);
  const [state, setState] = useState(defaultImage);
  const [currentFuel_One, setCurrentFuel_One] = useState(null);

  const [flight_One, setFlight_One] = useState(null);
  const [stateTwo, setStateTwo] = useState(defaultImage);
  const [currentFlight_One, setCurrentFlight_One] = useState(null);

  const [flight_Two, setFlight_Two] = useState(null);
  const [stateThree, setStateThree] = useState(defaultImage);
  const [currentFlight_Two, setCurrentFlight_Two] = useState(null);

  const [IamUser, setIamUser] = useState(null);

  useEffect(() => {
    setIamUser(iAmOwner());
    //getTrip();
    getOwnerUserName(thisTrip.owner_id);
    getPilotUsername(thisTrip.pilot_id).then(() => {
      // setLoading(false);
      console.log("setLoading(false)");
    });
    // if (iAmOwner()) {
    //   subTripOwner();
    //   //setDBimages();
    // } else {
    //   subTripPilot();
    //   //setDBimages();
    // }

    // setDBimages();
    //setLoading(false);
    let p1 = Promise.resolve(50);
    let p2 = 200;
    let p3 = new Promise(function (resolve, reject) {
      setTimeout(resolve, 100, "geek");
    });

    Promise.all([p1, p2, p3, getDoc(app.firestore(), `Trips`, id)]).then(
      function (values) {
        // document.write(values);
        console.log(values);
        setThisTrip(values[3]);
        setOwnerChecklist_Id(values[3].trip_checklist_owner.id);
        setPilotChecklist_Id(values[3].trip_checklist_pilot.id);

        setLoading(false);
      }
    );
  }, [loading]); //  Run once on load

  const getTrip = () => {
    setThisTrip({});

    const db = app.firestore();
    const subscriber = db
      .collection(`Trips`)
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          setThisTrip(doc.data());
          setOwnerChecklist_Id(doc.data().trip_checklist_owner.id);
          setPilotChecklist_Id(doc.data().trip_checklist_pilot.id);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
          setThisTrip(null);
        }
        // setLoading(false);
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
    return () => subscriber();
  };

  const subTripOwner = () => {
    // console.log("ownerChecklist_Id  => " + ownerChecklist_Id);
    console.log("trip id  => " + id);
    const subscriber = app
      .firestore()
      .collection(`Trips/${id}/checklist_owner`)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " ===========> ", doc.data());
          setOwnerChecklist_Id(doc.id);
          setThisTripContract(doc.data());
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
    return () => subscriber();
  };

  const [ownerName, setOwnerName] = useState("");
  const getOwnerUserName = (userId) => {
    app
      .firestore()
      .collection(`chatUsers`)
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          setOwnerName(`${doc.data().firstName} ${doc.data().lastName}`);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  };

  const [pilotName, setPilotName] = useState("");
  const getPilotUsername = async (userId) => {
    app
      .firestore()
      .collection(`chatUsers`)
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          setPilotName(`${doc.data().firstName} ${doc.data().lastName}`);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  };

  // DropZone
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  // DropZone

  function iAmOwner() {
    console.log("iAmOwner");
    return thisTrip.owner_id === app.auth().currentUser.uid;
  }

  //
  //   //
  //   //
  //   //
  //   //
  //   //
  //   //
  //   //
  //   //
  //   //
  //
  if (loading) {
    return <h1>loading firebase data...</h1>;
  }
  return (
    <Container>
      <div className={classes.root}>
        <p> trip id: {id}</p>
        <p> trip sub id: {IamUser ? ownerChecklist_Id : pilotChecklist_Id}</p>
        <p>
          {" "}
          trip sub object:{" "}
          {thisTripContract.checkInState_Out ? "true" : "false"}
          {/* {console.log("log 1 ", thisTripContract)} */}
        </p>
        {/* <p>{thisTrip}</p> */}
        <List>
          <ListItem style={{ backgroundColor: "lightgray" }}>
            <ListItemText>
              <Typography>Location</Typography>
            </ListItemText>
            <Typography>{thisTrip.planes_location}</Typography>
            {/* <Typography>Newark Liberty International Airport</Typography> */}
            {/* Should only be airport names */}
            {/* Diamond DA40 NG */}
            {/* {props.tripData.planes_location} */}
          </ListItem>
          <ListItem style={{ backgroundColor: "white" }}>
            <ListItemText>
              <Typography>Plane Owner</Typography>
            </ListItemText>
            <Typography>
              {" "}
              {ownerName}
              {/* Melek Izzet */}
              {/* Joe Smith */}
              {/* {props.tripData.owner_id} */}
            </Typography>
          </ListItem>
          <ListItem style={{ backgroundColor: "lightgray" }}>
            <ListItemText>
              <Typography>Pilot Renter</Typography>
            </ListItemText>
            <Typography>
              {pilotName}
              {/* Joe Smith */}
              {/* Get pilot from trips*/}
            </Typography>
          </ListItem>
          {/* </List> */}
          {/* <OwnerTripChecklist trip_id={id} /> */}
          {/* <TripChecklistOwner /> */}
          {/* ========================================================================================= */}
          {IamUser && (
            // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Owner Form %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
            <div>
              <h3>TripContractOwnerForm</h3>
              <TripContractOwnerForm
                tripId={id}
                // ownerChecklist={thisTripContract}
                ownerChecklist_Id={ownerChecklist_Id}
              />
            </div>
          )}
          {!IamUser && (
            // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Pilot Form %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
            <div>
              <h3>TripContractPilotForm</h3>
              <TripContractPilotForm
                tripId={id}
                //pilotChecklist={thisTripContract}
                pilotChecklist_Id={pilotChecklist_Id}
              />
            </div>
          )}
        </List>
      </div>
    </Container>
  );
};

export default TripContract;
